/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import "./Footer.css";
import icon from "../img/play.svg";

function Footer() {
    return (
        <footer id="footer" className="content">            
              <p className={"tex"} variant={"subtitle2"}>
              It's a learning based blogging social media where you can post articles, play battle quiz, make friends, like and  comment on posts.
              </p>
              <a href="https://play.google.com/store/apps/details?id=org.jhm69.battle_of_quiz" target="_blank">
              <img height={30} src={icon}/>
              </a>
        </footer>
    );
};

export default Footer;
